import React from 'react';

export interface CollapsibleFadePanelProps {
  expanded: boolean;
  panelId?: string;
  labelledBy?: string;
  tourId?: string;
  children: React.ReactNode;
  className?: string;
  innerClassName?: string;
}

/**
 * Expand and collapse with the library filter motion:
 * grid row 0fr/1fr, fade, and a short upward slide, 200ms ease-out both ways.
 */
export const CollapsibleFadePanel: React.FC<CollapsibleFadePanelProps> = ({
  expanded,
  panelId,
  labelledBy,
  tourId,
  children,
  className = '',
  innerClassName = ''
}) => (
  <div
    id={panelId}
    {...(labelledBy ? { role: 'region' as const, 'aria-labelledby': labelledBy } : {})}
    {...(tourId ? { 'data-tour-id': tourId } : {})}
    className={`grid overflow-hidden transition-[grid-template-rows,opacity,margin-top] duration-200 ease-out motion-reduce:transition-none ${
      expanded ? 'opacity-100' : 'opacity-0'
    } ${className}`}
    style={{ gridTemplateRows: expanded ? '1fr' : '0fr' }}
  >
    <div className="min-h-0 overflow-hidden">
      <div
        className={`transition-[transform,opacity] duration-200 ease-out motion-reduce:transition-none ${
          expanded ? 'translate-y-0 opacity-100' : '-translate-y-2 opacity-0'
        } ${innerClassName}`}
      >
        {children}
      </div>
    </div>
  </div>
);
